import { Box, Button, FormControl, FormControlLabel, FormLabel, Modal, Radio, RadioGroup, Typography } from "@mui/material";
import { useEffect, useState } from "react";

export const AvailabilityModal = ({ open, onClose, analyst, toggleAvailability }) => {
  const [availability, setAvailability] = useState(null);

  const handleAvailabilityChange = (event) => {
    setAvailability(event.target.value === 'available');
  };

  const handleSave = () => {
    toggleAvailability(analyst?.analyst_id, availability);
    onClose();
  };

  useEffect(() => {
    if (open) {
      setAvailability(analyst?.availability);
    }
  }, [open, analyst]);

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'white',
        boxShadow: 24,
        p: 4,
        borderRadius: 8,
        textAlign: 'center',
      }}>
        <Typography variant="h6" sx={{ fontWeight: 600, marginBottom: 2 }}>
          Set Availability Status
        </Typography>
        <Typography variant="subtitle1" color="text.secondary" sx={{ marginBottom: 2 }}>
          You're about to update the availability status for:
        </Typography>
        <Typography variant="h5" color="text.primary" sx={{ fontWeight: 600, marginBottom: 3 }}>
          {analyst?.analyst_id}
        </Typography>
        <FormControl component="fieldset">
          <FormLabel component="legend" sx={{ marginBottom: 2 }}>Mark Availability</FormLabel>
          <RadioGroup
            aria-label="availability"
            name="availability"
            value={availability ? 'available' : 'unavailable'}
            onChange={handleAvailabilityChange}
            row
          >
            <FormControlLabel value="available" control={<Radio />} label="Present" sx={{ marginRight: 3 }} />
            <FormControlLabel value="unavailable" control={<Radio />} label="Leave" />
          </RadioGroup>
        </FormControl>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: 3 }}>
          <Button variant="outlined" onClick={onClose} sx={{ marginRight: 2 }}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleSave}
            sx={{
              backgroundColor: '#4caf50',
              color: 'white',
              '&:hover': {
                backgroundColor: '#45a049', // Change hover color
              },
            }}
          >
            Save
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
